import { render, staticRenderFns } from "./AdminModal.vue?vue&type=template&id=4ff0fba7&scoped=true"
import script from "./AdminModal.vue?vue&type=script&lang=ts"
export * from "./AdminModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff0fba7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ff0fba7')) {
      api.createRecord('4ff0fba7', component.options)
    } else {
      api.reload('4ff0fba7', component.options)
    }
    module.hot.accept("./AdminModal.vue?vue&type=template&id=4ff0fba7&scoped=true", function () {
      api.rerender('4ff0fba7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/AdminModal.vue"
export default component.exports